.market {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-disabled);

  &.marketOpen {
    color: var(--success--default);
  }
}

.dotIcon {
  fill: var(--icon-disabled);
  margin-right: 8px;

  &.marketOpen {
    fill: var(--success--default);
  }
}
